export const ignoreResizeObserverFn = (errorEvent) => 
  // TODO: we are ignoring this type of warning (ResizeObserver), since it is due to an internal error in the Antd library
  // and the use of tables with virtual property. The idea is to deprecate this library so we leave a TODO to
  // eliminate this ignore.

   errorEvent && errorEvent.message && /^ResizeObserver/.test(errorEvent.message)
;

export default {
  beta: [
    'cwr',
    'b9db36aa-c3f1-45ce-80fc-49bfea7ed482',
    process.env.VERSION,
    'us-east-1',
    '/custom-cwr-next.js',
    {
      sessionSampleRate: 1,
      telemetries: [
        'performance',
        [
          'errors',
          {
            stackTraceLength: 10000,
            ignore: ignoreResizeObserverFn,
          },
        ],
        ['http', { recordAllRequests: true, addXRayTraceIdHeader: true, stackTraceLength: 10000 }],
      ],
      allowCookies: true,
      enableXRay: true,
      sessionEventLimit: 0,
      signing: false,
    },
  ],
  gamma: [
    'cwr',
    '95da0af4-c9e2-4ba3-bc3b-eb91d3bce07f',
    process.env.VERSION,
    'us-east-1',
    '/custom-cwr-next.js',
    {
      sessionSampleRate: 1,
      telemetries: [
        'performance',
        [
          'errors',
          {
            stackTraceLength: 10000,
            ignore: ignoreResizeObserverFn,
          },
        ],
        ['http', { recordAllRequests: true, addXRayTraceIdHeader: true, stackTraceLength: 10000 }],
      ],
      allowCookies: true,
      enableXRay: true,
      sessionEventLimit: 0,
      signing: false,
    },
  ],
  prod: [
    'cwr',
    '9430f41e-796d-4d5d-b06c-256ef3b8db54',
    process.env.VERSION,
    'us-east-1',
    '/custom-cwr-next.js',
    {
      sessionSampleRate: 1,
      telemetries: [
        'performance',
        [
          'errors',
          {
            stackTraceLength: 10000,
            ignore: ignoreResizeObserverFn,
          },
        ],
        ['http', { recordAllRequests: true, addXRayTraceIdHeader: true, stackTraceLength: 10000 }],
      ],
      allowCookies: true,
      enableXRay: true,
      sessionEventLimit: 0,
      signing: false,
    },
  ],
};
